import { render, staticRenderFns } from "./IframeViewModal.vue?vue&type=template&id=6a121edc&scoped=true&"
import script from "./IframeViewModal.vue?vue&type=script&lang=js&"
export * from "./IframeViewModal.vue?vue&type=script&lang=js&"
import style0 from "./IframeViewModal.vue?vue&type=style&index=0&id=6a121edc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a121edc",
  null
  
)

export default component.exports